import { render, staticRenderFns } from "./ConfirmRoleDialog.vue?vue&type=template&id=4ad42bd6&scoped=true"
import script from "./ConfirmRoleDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRoleDialog.vue?vue&type=style&index=0&id=4ad42bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad42bd6",
  null
  
)

export default component.exports